// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#edicionLeft .list_check>li .label_wicon svg{border-style:none;color:\"#8C8C8C\"!important;font-size:20px;margin-right:5px;vertical-align:middle;width:px}#edicionLeft .list_check>li .label_wicon b{display:inline-block;font-weight:400;padding:5px 0 0 10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
